<template>
  <v-container fluid pt-0>
    <v-row align="center" class="pb-2">
      <h1 class="headline">Tenants</h1>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" fab dark color="primary" @click="onCreateNew">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Create New Tenant</span>
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col class="pa-0">
        <v-data-table
          :items="items"
          :headers="headers"
          sort-by="name"
          class="elevation-1"
          loading-text="Loading... Please wait"
          :loading="$apollo.loading"
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              hide-edit
              :hide-view="false"
              @viewItem="onViewItem"
              @deleteItem="onDeleteItem"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <owner-details-dialog
      :show="showOwnerDetails"
      @close="showOwnerDetails = false"
      v-model="selectedOwner"
    ></owner-details-dialog>
    <new-tenant-dialog
      :show="showNewTenantDialog"
      @close="showNewTenantDialog = false"
      v-model="newTenant"
      @input="onNewTenantInput"
    ></new-tenant-dialog>
    <v-dialog v-model="deleteProgressDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          <p>Deleting Tenant...</p>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div v-if="debug">
      <code>{{ owners }}</code>
    </div>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";
import DefaultListActions from "../../shared/DefaultListActions";
import OwnerDetailsDialog from "./OwnerDetailsDialog";
import NewTenantDialog from "./NewTenantDialog.vue";

const OWNERS_QUERY = gql`
  query owners {
    owners {
      edges {
        node {
          id
          domain
          maxUsers
          name
          notes
          apiUrl
          tenantCode
          accessSettings {
            groupName
            settingName
            settingValue
          }
        }
      }
    }
  }
`;
const CREATE_TENANT_MUTATION = gql`
  mutation createOwner($input: CreateOwnerInput) {
    createOwner(input: $input) {
      id
      name
    }
  }
`;
const DELETE_TENANT_MUTATION = gql`
  mutation deleteOwner($id: ID!) {
    deleteOwner(id: $id) {
      id
    }
  }
`;
export default {
  name: "tenant-setup",

  components: {
    DefaultListActions,
    OwnerDetailsDialog,
    NewTenantDialog,
  },

  data() {
    return {
      debug: false,
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Domain",
          value: "domain",
          name: "domain",
        },
        {
          text: "Max Users",
          value: "maxUsers",
          name: "maxUsers",
        },
        {
          text: "Actions",
          value: "actions",
          name: "actions",
        },
      ],
      showOwnerDetails: false,
      selectedOwner: null,
      showNewTenantDialog: false,
      newTenant: null,

      deleteProgressDialog: false,
    };
  },

  computed: {
    items() {
      return this.owners && this.owners.edges
        ? this.owners.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onViewItem(item) {
      this.selectedOwner = { ...item };
      this.showOwnerDetails = true;
    },
    onDeleteItem(item) {
      this.deleteProgressDialog = true;
      this.$apollo
        .mutate({
          mutation: DELETE_TENANT_MUTATION,
          variables: { id: item.id },
          refetchQueries: [
            {
              query: OWNERS_QUERY,
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Tenant Deleted.",
          });
          this.deleteProgressDialog = false;
        })
        .catch((err) => {
          console.error("err", err);
          this.$store.dispatch("showAppSnackbar", {
            msg: "Tenant Deletion Failed.",
            color: "error",
          });
          this.deleteProgressDialog = false;
        });
    },
    onCreateNew() {
      this.newTenant = null;
      this.showNewTenantDialog = true;
    },
    onNewTenantInput(newTenant) {
      this.$apollo
        .mutate({
          mutation: CREATE_TENANT_MUTATION,
          variables: { input: newTenant },
          refetchQueries: [
            {
              query: OWNERS_QUERY,
            },
          ],
        })
        .then((resp) => {
          console.log("resp", resp);
          this.showNewTenantDialog = false;
          this.$store.dispatch("showAppSnackbar", {
            msg: "Tenant Created.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },

  apollo: {
    owners: {
      query: OWNERS_QUERY,
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/user-access-controls/TenantSetup.vue